import { env } from "../../env";

export const logger = store => next => action => {
  if (env?.NODE_ENV !== 'production') {
    console.group(action.type);
    console.info('dispatching', action);
    const result = next(action);
    console.log('next state', store.getState());
    console.groupEnd();
    return result;
  }
  return next(action);
};

export const crashReporter = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    console.error('Caught an exception!', err);
    throw err;
  }
};

// THIS MIDDLEWARE IS NOW FIXED - THE COOKIE LOGIC IS GONE
export const cookieMiddleware = store => next => action => {
  // Simply pass the action along. Do not manipulate cookies here.
  const result = next(action);
  
  // The authService is responsible for all cookie and localStorage side-effects.
  // This middleware should not be doing that work.
  
  return result;
};